import React from 'react';

/** Blue outline bell for the header notification control */
export default function NotificationBellIcon({ size = 22, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <path
        d='M12 3.25c-2.35 0-4.25 1.9-4.25 4.25v2.28c0 .58-.2 1.14-.57 1.58L5.8 13.8a1.25 1.25 0 0 0 .98 2.04h12.44a1.25 1.25 0 0 0 .98-2.04l-1.38-2.44a2.5 2.5 0 0 1-.57-1.58V7.5c0-2.35-1.9-4.25-4.25-4.25Z'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 17.25a2 2 0 0 0 4 0'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
    </svg>
  );
}
